import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import classes from './styles.module.css';
import Icon from '../../Utils/Icon';
import Loader from '../../Utils/Loader';

function ProjectsFilters({ onApplyFilters, isLoading }) {
    const [filters, setFilters] = useState({
        active: false,
        inactive: false,
        blocked: false,
    });

    function toggleFilter(key, value) {
        setFilters((prev) => ({ ...prev, [key]: value }));
    }

    return (
        <div className={classes.Card}>
            <div className={classes.Body}>
                <div className={classes.Group}>
                    <h6 className={classes.Title}>
                        <FormattedMessage id="ProjectsFilters.title.status" defaultMessage="Статус" />
                    </h6>

                    <div className={classes.Column}>
                        <div className={classes.CheckboxWrap}>
                            <input
                                id="active"
                                type="checkbox"
                                checked={filters.active}
                                onChange={(e) => toggleFilter('active', e.target.checked)}
                            />
                            <label htmlFor="active" className={classes.CustomCheckbox}>
                                <div className={classes.ActiveIcon} />
                                <span>
                                    <FormattedMessage id="ProjectsFilters.status.active" defaultMessage="Активен" />
                                </span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input
                                id="inactive"
                                type="checkbox"
                                checked={filters.inactive}
                                onChange={(e) => toggleFilter('inactive', e.target.checked)}
                            />
                            <label htmlFor="inactive" className={classes.CustomCheckbox}>
                                <div className={classes.InactiveIcon} />
                                <span>
                                    <FormattedMessage
                                        id="ProjectsFilters.status.inactive"
                                        defaultMessage="Не активен"
                                    />
                                </span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input
                                id="blocked"
                                type="checkbox"
                                checked={filters.blocked}
                                onChange={(e) => toggleFilter('blocked', e.target.checked)}
                            />
                            <label htmlFor="blocked" className={classes.CustomCheckbox}>
                                <div className={classes.BlockIcon} />
                                <span>
                                    <FormattedMessage
                                        id="ProjectsFilters.status.blocked"
                                        defaultMessage="Заблокирован"
                                    />
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div className={classes.Footer}>
                <button onClick={() => onApplyFilters(filters)} className={classes.Submit} disabled={isLoading}>
                    {!isLoading ? (
                        <Icon className={classes.buttonIcon} icon="filter" size="17px" />
                    ) : (
                        <Loader isString={true} />
                    )}
                    <FormattedMessage id="ProjectsFilters.btn.filter" defaultMessage="Фильтровать" />
                </button>
            </div>
        </div>
    );
}

export default ProjectsFilters;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/ProjectsFilters/index.js